export enum Cookies {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  EXPIRATION_TIME = 'expiration_time',
  REFRESH_EXPIRATION_TIME = 'refresh_expiration_time'
}
